/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The LookML configuration. See https://docs.siffletdata.com/docs/looker.
 * If you don’t use LookML or omit this field, it will default to an empty list.
 *
 */
export type GitConnection = {
    authType: GitConnection.authType;
    branch?: string;
    secretId: string;
    url: string;
};

export namespace GitConnection {

    export enum authType {
        HTTP_AUTHORIZATION_HEADER = 'HTTP_AUTHORIZATION_HEADER',
        USER_PASSWORD = 'USER_PASSWORD',
        SSH = 'SSH',
    }


}
